const PROGRAM_BACKGROUND_SOURCE = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/program-bg.png"
const PROGRAM_BUTTON_1_SOURCE = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/program-btn-1.png"
const PROGRAM_BUTTON_2_SOURCE = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/program-btn-2.png"
const PROGRAM_BUTTON_3_SOURCE = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/program-btn-3.png"
const PROGRAM_BUTTON_4_SOURCE = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/program-btn-4.png"
const TROPHY_SOURCE = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/trophy.png"

// Navigation button data
const navigationButtons = [
  {
    imgSrc: PROGRAM_BUTTON_1_SOURCE,
    altText: "策展理念",
    targetId: "intro"
  },
  {
    imgSrc: PROGRAM_BUTTON_2_SOURCE,
    altText: "影展期間",
    targetId: "period"
  },
  {
    imgSrc: PROGRAM_BUTTON_3_SOURCE,
    altText: "入圍名單",
    targetId: "candidates"
  },
  {
    imgSrc: PROGRAM_BUTTON_4_SOURCE,
    altText: "參展須知",
    targetId: "rules"
  }
];

// Reusable Navigation Button Component
const NavigationButton = ({ imgSrc, altText, targetId, navClick }) => (
  <button className='w-1/3 bg-transparent relative group'>
    <img src={imgSrc} alt={altText} className="object-contain" onClick={() => navClick(targetId)} />
    {/* Left triangle */}
    <div className="absolute right-0 top-1/2 translate-x-full -translate-y-1/2 w-0 h-0 border-t-[10px] border-t-transparent border-b-[10px] border-b-transparent border-r-[15px] border-r-[#DFB750] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    {/* Right triangle */}
    <div className="absolute left-0 top-1/2 -translate-x-full -translate-y-1/2 w-0 h-0 border-t-[10px] border-t-transparent border-b-[10px] border-b-transparent border-l-[15px] border-l-[#DFB750] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
  </button>
);

export const GuideSection = () => {
  const navClick = id => {
    const target = document.getElementById(id);
    if (target) {
      window.scrollTo({ 'behavior': 'smooth', 'top': target.offsetTop });
    }
  }

  return (
    <section 
      id="top" 
      className="py-10 relative bg-[#7B2337]"
    >
      <div className="container mx-auto h-full flex flex-col md:flex-row items-center justify-center md:justify-between px-4 md:px-10">
        {/* Trophy Image - Left side on md+ */}
        <div className="w-full md:w-1/2 flex justify-center mb-8 md:mb-0">
          <img 
            src={TROPHY_SOURCE} 
            alt="金逃影展獎盃" 
            className="w-40 lg:w-80 object-contain"
          />
        </div>
        
        {/* Navigation div - Right side on md+ */}
        <div className='w-full md:w-1/2 flex justify-center relative'>
          <img 
            src={PROGRAM_BACKGROUND_SOURCE} 
            alt="金逃影展" 
            className="w-full object-contain hover:cursor-pointer" 
            onClick={() => navClick("hero")}
          />
          <div className='absolute bottom-8 lg:bottom-12 w-full flex flex-col justify-center items-center gap-y-2'>
            {navigationButtons.map((button, index) => (
              <NavigationButton
                key={index}
                imgSrc={button.imgSrc}
                altText={button.altText}
                targetId={button.targetId}
                navClick={navClick}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
};

export const PeriodSection = () => (
  <section id="period" className="py-10 bg-[#317E70]"> 
    <div className="container mx-auto px-10 text-white font-bold">
      <h3 className='relative mb-6 text-2xl md:text-3xl'>
        <span className="absolute -left-4 top-1/2 -translate-y-1/2 w-[6px] h-[28px] bg-[#DFB750]"></span>
        影展期間
      </h3>
      {/* {isEnded && <h6 className='mb-4 text-xl md:text-2xl'>第四屆金逃獎已經公布完整得獎名單！</h6>} */}
      <p className='mb-4 text-lg md:text-xl text-white'>第一階段：2025/7/18 ~ 7/27，邀請 150 位資深玩家自 2024 年推出的遊戲中進行提名。</p>
      <p className='mb-4 text-lg md:text-xl text-[#DFB750]'>第二階段：2025/8/01 ~ 8/10，此階段開始前註冊的玩家皆有投票資格，一起來支持你心目中最佳的 2024 年度遊戲！</p>
      {/* <h3 className='relative text-2xl md:text-3xl'>
        <span className="absolute -left-4 top-1/2 -translate-y-1/2 w-[6px] h-[28px] bg-[#DFB750]"></span>
        入圍與得獎名單
      </h3> */}
    </div>
  </section>
);